<template>
    <div class="w-100 h-100">
        <b-modal
            v-model="showModal"
            hide-header
            hide-header-close
            centered
            @ok="clearFields"
        >
            <div class="text-center">
                <div>{{ModalMessage}}</div>
            </div>
        </b-modal>
      <b-container fluid>
        <h2 class="tw-mb-0 text-aegis-dk">Blood Sample Receiving</h2>
        <p class="tw-italic tw-text-gray-700">
          First stage in blood sample processing
        </p>
      </b-container>
      <br />

      <!-- Show this row when page first loads -->
      <b-row v-if="blood_sample_analysis_id == ''">
        <b-col cols="3"></b-col>
        <b-col cols="4">
            <b-form-input
                v-model="blood_sample_id"
                placeholder="Scan Blood Sample ID"
                @keypress.enter="getBloodSampleAnalysis"
            ></b-form-input>
        </b-col>
        <b-col cols="2">
            <b-button
                @click="getBloodSampleAnalysis"
                :disabled="blood_sample_id == ''"
            >Submit</b-button>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
      <!--  -->
      <b-row v-else>
        <b-col cols="3"></b-col>
        <b-col cols="6">
            <b-row>
                <b-col><h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">Scan Aliquots for Blood Sample ID: {{ blood_sample_id }}</h1></b-col>
            </b-row>
            <b-row>
                <b-col class="mt-2">
                    <b-form-group
                        :id='aliquot_base_id'
                        :label="'Scan Aliquot Base ID'"
                    >
                        <b-form-input
                            v-model="aliquot_base_id"
                            placeholder="Scan Aliquot Base ID"
                            @keypress.enter="populateAliquotIds"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <span v-for="field in form_fields" :key="field.key">
                <b-row v-if="field.key == 'aliquot1_id'"><b-col class="font-weight-bold">Aliquot 1:</b-col></b-row>
                <b-row v-if="field.key == 'aliquot2_id'"><b-col class="font-weight-bold">Aliquot 2:</b-col></b-row>
                <b-row v-if="field.key == 'aliquot3_id'"><b-col class="font-weight-bold">Aliquot 3:</b-col></b-row>
                <b-row v-if="field.key == 'aliquot4_id'"><b-col class="font-weight-bold">Aliquot 4:</b-col></b-row>
                <b-row class="mt-2">
                    <b-col>
                        <b-form-group
                            :id=field.key
                            :label=field.text
                        >
                            <!-- Read-only for aliquot#_ids -->
                            <b-form-input
                                v-model="field.value"
                                :placeholder=field.text
                                :plaintext="field.key === 'aliquot1_id' || field.key === 'aliquot2_id' || field.key === 'aliquot3_id' || field.key === 'aliquot4_id'"
                            ></b-form-input>

                        </b-form-group>
                    </b-col>
                </b-row>
            </span>
            <b-button
                class="mt-2"
                variant="success"
                size="lg"
                block
                @click="getBloodSampleAnalysis('update')"
                :disabled="processing_submit_disabled"
            >Submit aliquot barcodes</b-button>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
    </div>
  </template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import * as _ from "lodash";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
mixins: [
    DashboardBaseTemplate,
],
components: {},
props: {},
data: function() {
    return {
        showModal: false,
        ModalMessage: '',
        blood_sample_id: '',
        blood_sample_analysis_id: '',
        aliquot_base_id: '',
        form_fields: [
            { key: 'aliquot1_id', value: '', text: 'Aliquot 1 Barcode' },
            { key: 'aliquot1_box_num', value: '', text: 'Aliquot 1 Box #' },
            { key: 'aliquot1_freezer_num', value: '', text: 'Aliquot 1 Freezer #' },
            { key: 'aliquot1_shelf_num', value: '', text: 'Aliquot 1 Shelf #' },
            { key: 'aliquot2_id', value: '', text: 'Aliquot 2 Barcode' },
            { key: 'aliquot2_box_num', value: '', text: 'Aliquot 2 Box #' },
            { key: 'aliquot2_freezer_num', value: '', text: 'Aliquot 2 Freezer #' },
            { key: 'aliquot2_shelf_num', value: '', text: 'Aliquot 2 Shelf #' },
            { key: 'aliquot3_id', value: '', text: 'Aliquot 3 Barcode' },
            { key: 'aliquot3_box_num', value: '', text: 'Aliquot 3 Box #' },
            { key: 'aliquot3_freezer_num', value: '', text: 'Aliquot 3 Freezer #' },
            { key: 'aliquot3_shelf_num', value: '', text: 'Aliquot 3 Shelf #' },
            { key: 'aliquot4_id', value: '', text: 'Aliquot 4 Barcode' },
            { key: 'aliquot4_box_num', value: '', text: 'Aliquot 4 Box #' },
            { key: 'aliquot4_freezer_num', value: '', text: 'Aliquot 4 Freezer #' },
            { key: 'aliquot4_shelf_num', value: '', text: 'Aliquot 4 Shelf #' },
        ],
    };
},
computed: {
    processing_submit_disabled:function () {
        let disabled = false;
        if (this.aliquot_base_id == '') {
            disabled = true;
        }
        _.each(this.form_fields, function(field) {
            if (field.value == null || field.value == '') {
                disabled = true;
            }
        });
        return disabled;
    }
},
watch: {
    aliquot_base_id() {
      this.populateAliquotIds();
    },
},
created: function() {},
mounted: function() {},
methods: {
    getBloodSampleAnalysis: function(mode) {
        const that = this;
        const fd = new FormData();
        fd.append("blood_sample_id", that.blood_sample_id);
        if (mode) {
            fd.append("mode", mode);
            _.each(this.form_fields, function(field) {
                fd.append(field.key, field.value);
            });
        }
        HTTP.post('srilanka/blood_sample/initial_blood_sample_analysis/', fd).then((response) => {
            that.blood_sample_analysis_id = response.data.blood_sample_analysis_id;
            _.each(that.form_fields, function(field) {
                field.value = response.data[field.key];
            });
            if (mode == 'update') {
                this.ModalMessage = 'Submitted successfully';
                this.showModal = true;
            }
        }).catch((error) => {
            HandleErrors.HandleErrors(error);
            this.ModalMessage = 'There was a problem. Please check input values and try again.';
            this.showModal = true;
        });
    },
    populateAliquotIds() {
        this.form_fields.find(field => field.key === 'aliquot1_id').value = this.aliquot_base_id + '-A';
        this.form_fields.find(field => field.key === 'aliquot2_id').value = this.aliquot_base_id + '-B';
        this.form_fields.find(field => field.key === 'aliquot3_id').value = this.aliquot_base_id + '-C';
        this.form_fields.find(field => field.key === 'aliquot4_id').value = this.aliquot_base_id + '-D';

    },
    clearFields() {
        this.blood_sample_id = '';
        this.blood_sample_analysis_id = '';
        this.aliquot_base_id = '';
        _.each(this.form_fields, function(field) {
            field.value = '';
        });
    }
}
};
</script>

<style scoped></style>
